import React from 'react';
// eslint-disable-next-line webflow/no-dangerous-imports
import PropertyList, {
  PropertyListItem,
  PropertyListNone,
} from '@packages/systems/ui/shared-ui/PropertyList';
import {styled, emotionStyled} from '@packages/utilities/styled';
import {
  getNodeClickedActionCreatorFromState,
  getNodeHoveredActionCreatorFromState,
} from '@packages/systems/designer/canvas';

import Hitarea from '@packages/systems/design-system/Hitarea';

import {FieldPasswordSmall as Password} from '@packages/systems/ui/icons';
import {useDispatch, useFluxContext} from '@packages/systems/designer/flux';

import {
  FieldSwitchIcon as Bool,
  EmailIcon as Email,
  AttachmentIcon as FileRef,
  LinkIcon as Link,
  FieldNumberIcon as Number,
  FieldOptionIcon as FieldOptionSmall,
  FieldTextIcon as PlainText,
} from '@packages/systems/spring';

const Icons = {
  Bool,
  Email,
  PlainText,
  Password,
  Number,
  Option: FieldOptionSmall,
  Link,
  FileRef,
} as const;

import type {InputDataPOJO, SelectTargetIdMap} from './UserFormType';

const Flex = emotionStyled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const AddButtonContainer = emotionStyled('div')({
  display: 'flex',
  gridTemplateColumns: '1fr 1fr',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '26px',
});

const SelectableListItem = styled(PropertyListItem)(
  {
    height: '32px',
  },
  {
    hover: ({theme}) => ({
      backgroundColor: theme.colors.backgroundVivid,
    }),
  }
);

// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type.
const UserFieldIcon = ({type}) => {
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Bool: ForwardRefExoticComponent<BaseIconProps & RefAttributes<HTMLElement>>; readonly Email: ForwardRefExoticComponent<BaseIconProps & RefAttributes<...>>; ... 5 more ...; readonly FileRef: ForwardRefExoticComponent<...>; }'.
  const Icon = Icons[type];
  return Icon ? <Icon /> : null;
};

const renderNone = () => <PropertyListNone label="No inputs" />;

const UserAddFields = ({
  inputs,
  deleteField,
  selectContainerId,
}: {
  inputs: InputDataPOJO[];
  deleteField: (elementId: string, fieldType: string) => void;
  selectContainerId: SelectTargetIdMap;
}) => {
  const flux = useFluxContext();

  const wfDispatch = useDispatch();
  const nodeClicked = getNodeClickedActionCreatorFromState(flux.state);
  const nodeHovered = getNodeHoveredActionCreatorFromState(flux.state);

  const [commonInputs, customInputs] = inputs.reduce(
    (acc, input) => {
      if (input.custom === false) {
        // @ts-expect-error - TS2345 - Argument of type 'InputDataPOJO' is not assignable to parameter of type 'never'.
        acc[0].push(input);
      } else {
        // @ts-expect-error - TS2345 - Argument of type 'InputDataPOJO' is not assignable to parameter of type 'never'.
        acc[1].push(input);
      }
      return acc;
    },
    [[], []]
  );

  const renderListItem = (
    // @ts-expect-error - TS7031 - Binding element 'name' implicitly has an 'any' type. | TS7031 - Binding element 'deletable' implicitly has an 'any' type. | TS7031 - Binding element 'elementId' implicitly has an 'any' type. | TS7031 - Binding element 'fieldType' implicitly has an 'any' type.
    {item: {name, deletable, elementId, fieldType}},
    idx: number
  ) => {
    return (
      <Hitarea key={idx}>
        <SelectableListItem
          showIconsByDefault
          onClick={() => {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            const targetId = selectContainerId[fieldType](elementId);
            wfDispatch(
              nodeClicked({
                nativeIdInCurrentComponent: targetId,
              })
            );
          }}
          onMouseEnter={() => {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            const targetId = selectContainerId[fieldType](elementId);
            wfDispatch(
              nodeHovered({
                nativeIdInCurrentComponent: targetId,
              })
            );
          }}
          onMouseLeave={() => {
            wfDispatch(
              nodeHovered({
                nativeIdInCurrentComponent: null,
              })
            );
          }}
          onDeleteButtonClicked={
            deletable ? () => deleteField(elementId, fieldType) : false
          }
          id={String(idx)}
          key={idx}
          label={name}
          icon={<UserFieldIcon type={fieldType} />}
        />
      </Hitarea>
    );
  };

  return (
    <Flex>
      <div data-automation-id="usys-form-common-fields">
        <AddButtonContainer>
          <span>Common fields</span>
        </AddButtonContainer>
        <PropertyList
          disabled={false}
          items={commonInputs.map((item, fieldId) => ({
            item,
            id: String(fieldId),
          }))}
          renderItem={renderListItem}
          renderNone={renderNone}
        />
      </div>
      <div data-automation-id="usys-form-custom-fields">
        <AddButtonContainer>
          <span>Custom fields</span>
        </AddButtonContainer>
        <PropertyList
          disabled={false}
          items={customInputs.map((item, fieldId) => ({
            item,
            id: String(fieldId),
          }))}
          renderItem={renderListItem}
          renderNone={renderNone}
        />
      </div>
    </Flex>
  );
};

export default UserAddFields;
